<template>
  <div class="wrapper">
    <a href="https://onatcer.com" class="badge">
      <img width="35" height="35" src="/static/onatcer.jpg" alt="">
      <div>made by Gregor Vostrak (@onatcer)</div>
    </a>
  </div>

</template>

<script>

  export default {
    name: 'Badge',
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .badge {
    background-color: #FFF;
    position: fixed;
    bottom: 0;
    right: 0;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.16);
    padding: 10px 5px;
    display: grid;
    grid-template-columns: 1fr 6fr;
    border-radius: 15px 0 0 0;
    font-weight: 700;
    font-size: 1rem;
    z-index: 100000;
    color: #C86DD7;
  }
  .badge div{
    background-image:linear-gradient(-70deg, #3023AE, #C86DD7);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .badge::after {
    display: none;
  }

  .badge img {
    border-radius: 50%;
    margin: 0 2px;

  }

  .badge div {
    align-self: center;
  }

  .wrapper {
    display: grid;
    grid-template-columns: 20px 210px;
  }

  .Cookie {
    padding-right: 250px;
    height: 55px;
    background-color: #FFF;
  }
</style>



// WEBPACK FOOTER //
// Badge.vue?38edbea4